import { BillingPeriod } from '../domain/subscription/Subscription';
import { SubscriptionInvoice } from '../domain/subscription/SubscriptionInvoice';
import { subscriptionRepository } from '../repositories/subscription';
import { Pricing, SubscriptionRepository } from '../repositories/subscription/SubscriptionRepository';

export class SubscriptionService {
  constructor(private subscriptionRepository: SubscriptionRepository) {}

  async fetchInvoices(): Promise<SubscriptionInvoice[]> {
    return this.subscriptionRepository.fetchInvoices();
  }

  async createPortalSession(returnUrl: string): Promise<string> {
    return this.subscriptionRepository.createPortalSession(returnUrl);
  }

  async getPricing({ billingPeriod }: { billingPeriod?: BillingPeriod }): Promise<Pricing> {
    return this.subscriptionRepository.getPricing({ billingPeriod });
  }
}

export const subscriptionService = new SubscriptionService(subscriptionRepository);
